import LandingPagesTable from "./LandingPagesTable";

const TopLandingPagesTab = ({ landingPages }) => <LandingPagesTable landingPages={landingPages} />;

export default TopLandingPagesTab;
